import { createFilterSelectList } from '@adv-frontend/filters';
import { type OpenApiSchemaPriceIndexMarketplace } from '#shared/api/schema';
import { OZON_SERVICE_NAME } from '#shared/lib/brand';
import {
    PRICE_INDEX_CHEAPEST_MARKETPLACE_FILTER_ID,
    PRICE_INDEX_CHEAPEST_MARKETPLACE_FILTER_TITLE,
} from '../../constants';

type Item<ID extends OpenApiSchemaPriceIndexMarketplace = OpenApiSchemaPriceIndexMarketplace> = {
    id: ID;
    label: string;
};

const items: Item[] = [
    {
        id: 'ozon',
        label: OZON_SERVICE_NAME,
    },
];

export const isPriceIndexMarketplace = (value?: string): value is OpenApiSchemaPriceIndexMarketplace => {
    if (!value) {
        return false;
    }

    return items.some(({ id }) => id === value);
};

export const createPriceIndexCheapestMarketplaceFilter = () =>
    createFilterSelectList<typeof PRICE_INDEX_CHEAPEST_MARKETPLACE_FILTER_ID, OpenApiSchemaPriceIndexMarketplace>({
        id: PRICE_INDEX_CHEAPEST_MARKETPLACE_FILTER_ID,
        title: PRICE_INDEX_CHEAPEST_MARKETPLACE_FILTER_TITLE,
        isSingleSelect: true,
        items: items.map(({ id, label }) => {
            return {
                value: id,
                content: label,
            };
        }),
    });
